export default ({ request }) => ({
  ecomHxFtyInboundListApi(data = {}) {
    return request({
      url: '/ecom/hx/fty/inbound/list',
      method: 'POST',
      data,
    })
  },
  ecomHxFtyInboundDetailApi(data = {}) {
    return request({
      url: '/ecom/hx/fty/inbound/detail',
      method: 'POST',
      data,
    })
  },
  ecomHxFtyInboundGenerateApi(data = {}) {
    return request({
      url: '/ecom/hx/fty/inbound/generate',
      method: 'POST',
      data,
    })
  },
  ecomHxFtyInboundSaveApi(data = {}) {
    return request({
      url: '/ecom/hx/fty/inbound/save',
      method: 'POST',
      data,
    })
  },
  ecomHxFtyInboundDelApi(data = {}) {
    return request({
      url: '/ecom/hx/fty/inbound/del',
      method: 'POST',
      data,
    })
  },
  ecomHxFtyInboundAuditApi(data = {}) {
    return request({
      url: '/ecom/hx/fty/inbound/audit',
      method: 'POST',
      data,
    })
  },
  ecomHxFtyInboundDetailListApi(data = {}) {
    return request({
      url: '/ecom/hx/fty/inbound/detail/list',
      method: 'POST',
      data,
    })
  },
})
